<template>
  <div>
    <b-row>
      <b-col>
        <dl>
          <dt>Site</dt>
          <dd>
            <router-link :to="{
              name: 'site',
              params: { siteId: opportunity.site.siteId },
            }">{{ opportunity.site.name }}</router-link><br />
            {{ opportunity.site.streetAddress }}<br />
            {{ opportunity.site.city }}, {{ opportunity.site.state }}<br />
            {{ opportunity.site.zip }}<br />
          </dd>
          <dt v-if="opportunity.translationalTeam">Translational Team</dt>
          <dd v-if="opportunity.translationalTeam">
            <a :href="translationalTeamUrl + opportunity.translationalTeam.translationalTeamId" target="_blank">{{
              opportunity.translationalTeam.name }}</a>
          </dd>
          <dt>Minimum GPA</dt>
          <dd>
            <span v-if="!opportunity.recommendedGPA || opportunity.recommendedGPA === 0
              ">No requirement</span>
            <span v-if="opportunity.recommendedGPA && opportunity.recommendedGPA != 0
              ">{{ opportunity.recommendedGPA | number(2) }}</span>
          </dd>
          <dt>Recommended Credit Hours</dt>
          <dd>
            <span v-if="!opportunity.recommendedCreditHoursString ||
              opportunity.recommendedCreditHoursString === ''
              ">No requirement</span>
            <span v-if="opportunity.recommendedCreditHoursString != ''">{{
              opportunity.recommendedCreditHoursString
            }}</span>
          </dd>
          <dt v-if="isTranslationalTeam">Commitment Level</dt>
          <dd v-if="isTranslationalTeam">
            <span v-if="!opportunity.commitmentLevel ||
              opportunity.commitmentLevel === 0
              ">No requirement</span>
            <span v-if="opportunity.commitmentLevel != 0">{{
              opportunity.commitmentLevel
            }}</span>
          </dd>
        </dl>
      </b-col>
      <b-col>
        <div>
          <dl>
            <dt>Type / Category</dt>
            <dd>
              <b-badge v-if="opportunity.opportunityType" class="ml-1" variant="primary">{{
                opportunity.opportunityType.name }}</b-badge>
              <b-badge v-if="opportunity.opportunityCategory" class="ml-1" variant="primary">{{
                opportunity.opportunityCategory.name }}</b-badge>
            </dd>
          </dl>
        </div>

        <div v-if="opportunity.opportunityInternshipCourses.length">
          <dl>
            <dt>Courses</dt>
            <dd>
              <span v-for="oic in opportunity.opportunityInternshipCourses" :key="oic.internshipCourseId">
                <b-badge class="ml-1" variant="primary">{{
                  oic.internshipCourse.displayName
                }}</b-badge>
              </span>
            </dd>
          </dl>
        </div>

        <div v-if="opportunity.scheduleLineNumber">
          <dl>
            <dt>Assigned Class</dt>
            <dd>
              {{ opportunity.subjectCode | notAvailable }}
              {{ opportunity.catalogNumber | notAvailable }} ({{
                opportunity.scheduleLineNumber | notAvailable
              }})<br />
              {{ opportunity.sessionLd | notAvailable }} |
              {{ opportunity.locationCode | notAvailable }} |
              {{ opportunity.instructionMode | notAvailable }}
            </dd>
          </dl>
        </div>

        <div v-if="opportunity.opportunityAreaOfInterests.length">
          <dl>
            <dt>Areas of Interest</dt>
            <dd>
              <span v-for="oai in opportunity.opportunityAreaOfInterests" :key="oai.areaOfInterestId">
                <b-badge class="ml-1" variant="primary">{{
                  oai.areaOfInterest.name
                }}</b-badge>
              </span>
            </dd>
          </dl>
        </div>
        <div>
          <dl>
            <dt>Published</dt>
            <dd>{{ opportunity.published | trueOrFalse }}</dd>
            <dt>Semester</dt>
            <dd>{{ opportunity.term.description }}</dd>
          </dl>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col v-if="!isTranslationalTeam">
        <strong>How to Apply</strong>
        <ul>
          <li v-for="item in opportunity.opportunityApplicationTypes" :key="item.applicationTypeId">
            {{ item.applicationType.description }}
          </li>
          <li v-if="opportunity.applicationUrl">
            Application Url (
            <a :href="opportunity.applicationUrl" target="_blank">{{
              opportunity.applicationUrl
            }}</a>
            )
          </li>
        </ul>
      </b-col>
      <b-col>
        <strong>Additional Materials</strong>
        <additional-materials :additionalMaterialTypes="additionalMaterialTypes"></additional-materials>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <strong>Description</strong>
        <show-more :text="opportunity.description" v-if="opportunity.description"></show-more>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import ShowMore from "../../components/show-more";
import AdditionalMaterials from "../../components/opportunities/additional-materials";

export default {
  data() {
    return {};
  },

  props: {
    opportunity: {
      type: Object,
      required: true
    },

    applicationTypes: {
      type: Array,
      required: true
    }
  },

  components: {
    "show-more": ShowMore,
    "additional-materials": AdditionalMaterials
  },

  computed: {
    additionalMaterialTypes: function () {
      if (this.opportunity) {
        return _.map(
          this.opportunity.opportunityAdditionalMaterials,
          "additionalMaterialType"
        );
      }
      return [];
    },
    isTranslationalTeam: function () {
      if (
        this.opportunity &&
        this.opportunity.opportunityType &&
        this.opportunity.opportunityType.name == "Translational Team"
      ) {
        return true;
      }
      return false;
    },

    translationalTeamUrl: function () {
      if (process.env.NODE_ENV === "production") {
        return "https://translationalteams.chs.asu.edu/translational-teams/";
      } else if (process.env.NODE_ENV === "staging") {
        return "https://translationalteams-dev.chs.asu.edu/translational-teams/";
      }
      return "https://translationalteams-dev.chs.asu.edu/translational-teams/";
    }
  },

  methods: {
    deleteOpportunity: function () {
      this.$emit("delete");
    }
  }
};
</script>

<style scoped>
.dl-horizontal.align-left dt {
  text-align: left;
}

.badge-primary {
  background-color: #428bca;
  margin: 3px;
  padding: 5px;
}

h5 {
  font-size: 14px;
}

.btn-primary {
  margin: 3px;
}
</style>
